import {
  CardBody,
  Card,
  Label, Button} from '@polichat/flamboyant';
import React, { useState, useEffect } from 'react';
import Animation from 'src/components/common/animation';
import store from 'src/store';
import { fetchOpportunitiesAndTicketsRequest } from 'src/store/modules/chat/actions';
import { ChevronRightLineLight2 } from '@poli-digital/react';
import {Opportunities} from './OpportunitiesDetails'
import { Tickets } from './TicketsDetails';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

export function OpportunitiesAndTickets(props) {
  const contact = props.contact;
  const opportunitiesTitle = useGlotaT('spa.details.opportunities.title');
  const ticketsTitle = useGlotaT('spa.details.tickets.title');
  const errorFetchingText = useGlotaT('spa.details.errors.errorFetching');
  const tryAgainText = useGlotaT('spa.details.errors.tryAgain');
  let opportunities = props.cards?.opportunities?.data ;

  if (opportunities && opportunities.length > 1 && props.onlyFirst) {
    opportunities = [opportunities[0]]
  }
  let tickets = props.cards?.tickets?.data ;

  if (tickets && tickets.length > 1 && props.onlyFirst) {
    tickets = [tickets[0]]
  }
  const [cards, setCards] = useState(null);
  const [error, setError] = useState(false);
  const [loading,setLoading] = useState(true);
  const handleTryAgain = () => {
    setCards(null);
    setLoading(true)
    setError(false)
    store.dispatch(fetchOpportunitiesAndTicketsRequest(contact.id));
  };

  useEffect(() => {
    setCards(props.cards);
    if(props.cards !== null){
      setLoading(false)
    }
    if (props.cards === undefined) {
      setError(true)
    }
    return ()=>{
      setLoading(true);
    }
  }, [props.cards]);

  useEffect(() => {
    if (props.cards === null){
      setLoading(true);
      store.dispatch(fetchOpportunitiesAndTicketsRequest(contact.id));
    }
    return ()=>{
      setLoading(true);
    }
  }, [props.contact.id]);

  return (
    <>
      <div className="moreInfosOpportunities">
        <div className="title" onClick={props.toggleOpportunities}>
          <span>
            <strong>{opportunitiesTitle}</strong>
          </span>
          <ChevronRightLineLight2 />
        </div>
        <Card className="infoItemsContainer">
          <CardBody className="infoItems">
            {loading ? (
              <Animation icon="loading" top={'50%'} />
            ) : error ? (
              <>
                <Label>{errorFetchingText}</Label>
                <Button onClick={handleTryAgain}>{tryAgainText}</Button>{' '}
              </>
            ) : (
              <div>
                <Opportunities isOpen={props.isOpenOpportunities} toggleOpportunities={props.toggleOpportunities} opportunities={opportunities} openEmbedModal={props.openEmbedModal} fnSeeMore={cards?.opportunities?.pagination?.total > 1 && props.onlyFirst ?props.toggleOpportunities:null}  />
              </div>
            )}
          </CardBody>
        </Card>
      </div>
      <div className="moreInfosTickets">
        <div className="title" onClick={props.toggleTickets}>
          <span>
            <strong>{ticketsTitle}</strong>
          </span>
          <ChevronRightLineLight2 />
        </div>

        <Card className="infoItemsContainer">
          <CardBody className="infoItems">
            {loading ? (
              <Animation icon="loading" top={'50%'} />
            ) : error ? (
              <>
                <Label>{errorFetchingText}</Label>
                <Button onClick={handleTryAgain}>{tryAgainText}</Button>{' '}
              </>
            ) : (
              <Tickets isOpen={props.isOpenTickets} toggleTickets={props.toggleTickets} openEmbedModal={props.openEmbedModal} tickets={tickets} fnSeeMore={cards?.tickets?.pagination?.total > 1 && props.onlyFirst ?props.toggleTickets:null}  />
            )}
          </CardBody>
        </Card>
      </div>
    </>
  );
}
